import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const CheckMarkLine = ({ height = '24px', width = '24px', fill = 'currentColor', ...rest }) => {
    return (_jsx(BaseIcon, { width: width, height: height, viewBox: '0 0 12 12', fill: 'none', ...rest, children: _jsx("path", { fill: fill, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.1152 6.18197L2.64554 5.65165L4.98175 7.98792L9.29697 3.6727L9.8273 4.20303L4.98175 9.04858L2.1152 6.18197Z' }) }));
};
//# sourceMappingURL=CheckMarkLine.js.map